import { enqueueSnackbar } from "notistack";
import { useAppDispatch, useAppSelector } from "stores";

import { systemSlice } from "./reducers";

export const useSystemHook = () => {
  const dispatch = useAppDispatch();
  const organizationDialog = useAppSelector(
    (state) => state?.system.organizationDialog
  );

  const onToggleOrgDialog = () => {
    if (organizationDialog)
      dispatch(systemSlice.actions.hideOrganizationDialog());
    else dispatch(systemSlice.actions.showOrganizationDialog());
  };

  const showSnackbar = (message: string, type: "success" | "error") => {
    enqueueSnackbar(message, { variant: type });
  };

  return {
    organizationDialog,
    onToggleOrgDialog,
    showSnackbar,
  };
};
